<!-- svelte-ignore a11y-missing-attribute -->

<div class="box">
  {#if data.status === 'draft'}
    <article class="message is-success">
      <div class="message-body">
        This need is not yet published. Do you want to
        <a href={$url('../edit')}>continue editing</a>
        or
        <a
          on:click={() => {
            $uiState.activeModal = {
              component: ConfirmPublish,
              props: { item: { id, data } },
            };
          }}>publish now</a
        >?
      </div>
    </article>
  {:else if data.status === 'pending-approval'}
    <article class="message is-info">
      <div class="message-body">
        We're reviewing the need. If everything looks okay, we'll publish
        shortly.
      </div>
    </article>
  {:else if data.status === 'published'}
    <article class="message is-info">
      <div class="message-body">
        This need is published. If you need to edit the need, contact
        <a href="mailto:support@agoodthing.org.uk">support@agoodthing.org.uk</a>
        for assistance.
      </div>
    </article>
  {/if}

  <div class="columns">
    <div class="column is-narrow">
      {#if data.images?.[0]}
        <img
          alt="Offer"
          on:click={() => {
            $uiState.activeModal = {
              component: Lightbox,
              props: { images: data.images, index: 0 },
            };
          }}
          src={data.images[0]}
          style="width:240px; cursor:pointer;"
        />
      {:else}
        <img
          alt="Generic"
          src="/assets/img/box.png"
          style="height:240px;width:240px; background-color:lightgrey"
        />
      {/if}
      <div style="width:250px;">
        {#if data.images && data.images?.length > 1}
          {#each data.images as url, index}
            {#if index !== 0}
              <div style="display:inline-block;margin-right: 8px;">
                <img
                  alt="Offer"
                  on:click={() => {
                    $uiState.activeModal = {
                      component: Lightbox,
                      props: { images: data.images, index },
                    };
                  }}
                  src={url}
                  style="max-width:116px;"
                />
              </div>
            {/if}
          {/each}
        {/if}
      </div>
    </div>
    <div class="column">
      <p class="block is-size-4">{data.title || 'Untitled'}</p>
      {#if data.location?.postcode}
        <div class="block">
          <span class="tag is-light is-small">{data.location.postcode}</span>
        </div>
      {/if}
      <p class="block" style="white-space:pre-wrap;">{data.needs}</p>
      <p class="block" style="white-space:pre-wrap;">{data.benefits}</p>
      <p class="block" style="white-space:pre-wrap;">{data.background}</p>
    </div>
    <div class="column is-one-fifth">
      <div class="block is-pulled-right">
        {#if data.status === 'draft'}
          <a class="button" href={$url('../edit')}>Edit</a>&nbsp;

          <button
            class="button is-primary"
            on:click={() => {
              $uiState.activeModal = {
                component: ConfirmPublish,
                props: { item: { id, data } },
              };
            }}>Publish</button
          >
        {/if}
      </div>
    </div>
  </div>
</div>

<script lang="ts">
  export let scoped: {
    id: NeedId;
    data: Need_v1;
  };
  import _ from 'lodash';
  import { uiState } from '../../../../lib/uiState';
  import { appState } from '../../../../lib/appState';
  import { hasActiveSubscription } from '../../../../lib/subscriptionHelper';
  import { url } from '@sveltech/routify';
  import ConfirmPublish from './_components/ConfirmPublish.svelte';
  import Lightbox from '../../../_components/Lightbox.svelte';

  let id: string = scoped.id;
  $: data = scoped.data;
</script>